export const fridayAbbreviatedLowercase = "tra";
export default {fridayAbbreviatedLowercase};